import React from 'react';

import styled from '@tanium/react-emotion-9';
import { ThemeDefinition } from '@tanium/react-theme-definition';
import { css } from '@tanium/style-system';

import { StickyFooterBackground, StickyFooterStuckBoxShadow } from './themeDefinitions';
import { useStickyFooterIndicator } from './useStickyFooterIndicator';

const StickyContainer = styled('div', {
  shouldForwardProp: (p) => !['enableSticky', 'stickyBg', 'stuck'].includes(p),
})<{
  enableSticky: boolean;
  stickyBg: ThemeDefinition<string>;
  stuck: boolean;
}>(
  css({
    mt: 2,
    pb: 2,
    mb: 1,
  }),
  ({ enableSticky, stickyBg, stuck }) =>
    enableSticky && [
      css({
        position: 'sticky',
        bottom: 0,
      }),
      stuck &&
        css({
          bg: stickyBg,
          boxShadow: StickyFooterStuckBoxShadow,
          // -1px allows the sticky indicator to be used for intersection testing
          clipPath: 'inset(-10px 0 -1px)',
          mt: 0,
          pt: 2,
        }),
    ],
);

interface FormFooterProps {
  children: React.ReactNode;
  enableSticky: boolean;
  stickyBg: ThemeDefinition<string> | undefined;
}

export const FormFooter = ({
  enableSticky,
  children,
  stickyBg = StickyFooterBackground,
}: FormFooterProps) => {
  const { isStuck, stickyIndicator } = useStickyFooterIndicator({
    enableSticky,
  });

  return (
    <StickyContainer enableSticky={enableSticky} stuck={!!isStuck} stickyBg={stickyBg}>
      {children}
      {stickyIndicator}
    </StickyContainer>
  );
};
